import React from 'react';
import { Link } from 'react-router-dom';
import { getIsMobile } from '../../utils/getIsMobile';
import { useTranslation } from '../../utils/useTranslation';
import { Button } from '../input/Button';
import { DataTestId } from '../layout/DataTestIdWrapper';
import { Flex } from '../layout/Flex';
import { Typography } from '../typography/Typography';
import { MOBILE_FOOTER_HEIGHT } from './constants';
import { useHeaderSizes } from './hooks/useHeaderSizes';

export const CollectionEmpty = () => {
    const t = useTranslation();
    const { headerHeight } = useHeaderSizes();
    const { isMobile } = getIsMobile();
    const foooterHeight = isMobile ? MOBILE_FOOTER_HEIGHT : 0;

    return (
        <Flex
            px={4}
            height={`calc(100% - ${headerHeight}px - ${foooterHeight}px)`}
            justifyContent="center"
        >
            <Typography
                variant={isMobile ? 'title2' : 'title1'}
                weight="heavy"
                pb={3}
                dataTestId={DataTestId.EMPTY_COLLECTION_TEXT}
            >
                {t('В коллекции пока ничего нет, но вы можете найти интересное в ленте')}
            </Typography>
            <Button size="l" as={Link} to="/">
                {t('Перейти в ленту')}
            </Button>
        </Flex>
    );
};
